import { render, staticRenderFns } from "./AbnormalOrder.vue?vue&type=template&id=0f589f93&scoped=true&"
import script from "./AbnormalOrder.vue?vue&type=script&lang=js&"
export * from "./AbnormalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f589f93",
  null
  
)

export default component.exports